export default "__VITE_ASSET__48f02c18__"